import { useEffect, useState } from "react";
import PageContainer from "../components/admin/PageContainer";
// import Modal from "../components/Modal";
import CollapseCard from "../components/admin/CollapseCard";
import AdvertisementForm from "../components/admin/AdvertisementForm";
import AdvertisementList from "../components/admin/AdvertisementList";

import {
  fetchAllAdvertisement,
  createAdvertisement,
  updateAdvertisement,
  deleteAdvertisement,
  fetchAdvAttachmentsByAdId,
  deleteAdvAttachmentById,
} from "../service/AdService";
import Modal from "../components/admin/Modal";
import { useToast } from "../components/toast/ToastProvider";
import Main from "../components/admin/Main";
import { deleteVisitingTime, deleteVisitingTimeByAdId, fetchVisitingTimeByAdId, saveVisitingTime } from "../service/VisitingTime";

const Advertisement = () => {
  const [ads, setAds] = useState([]);
  const [selectedAd, setSelectedAd] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [viewMode, setViewMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const toast = useToast();
  const [deletingId, setDeletingId] = useState(null);
  const [removedVisitingIds, setRemovedVisitingIds] = useState([]);
  const [removedAttachmentIds, setRemovedAttachmentIds] = useState([]);

  const loadAds = async () => {
    try {
      setLoading(true);
      const res = await fetchAllAdvertisement();

      setAds(res);
    } catch (error) {
      toast("Error in fetch Advertisement", "ERROR");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadAds();
  }, []);

  const handleSave = async (adData, visitingTime) => {
    try {
      setSaving(true);
      const formData = new FormData();
      formData.append("category", adData.category);
      formData.append("location", adData.location);
      formData.append("title", adData.title);
      formData.append("address1", adData.address1);
      formData.append("address2", adData.address2);
      formData.append("address3", adData.address3);
      formData.append("address4", adData.address4);
      formData.append("phoneNo1", adData.phoneNo1);
      formData.append("phoneNo2", adData.phoneNo2);
      formData.append("phoneNo3", adData.phoneNo3);
      formData.append("description", adData.description);
      formData.append("webUrl", adData.webUrl || "");
      formData.append("fbLink", adData.fbLink || "");
      formData.append("wapLink", adData.wapLink || "");
      formData.append("ytLink", adData.ytLink || "");

      if (adData.imageUrl instanceof File) {
        formData.append("imageUrl", adData.imageUrl);
      } else if (typeof adData.imageUrl === "string" && adData.imageUrl) {
        formData.append("imageUrl", adData.imageUrl);
      }

      if (typeof adData.type === "string" && adData.type) {
        formData.append("type", adData.type);
      }

      if (Array.isArray(adData.pdfFiles)) {
        adData.pdfFiles.forEach((item) => {
          const file =
            item instanceof File ? item : item?.file instanceof File ? item.file : null;
          if (file) {
            formData.append("pdfFiles[]", file);
          }
        });
      }

      let adId = selectedAd?.id;
      let res;

      if (removedAttachmentIds.length > 0) {
        for (const attachmentId of removedAttachmentIds) {
          await deleteAdvAttachmentById(attachmentId);
        }
        setRemovedAttachmentIds([]);
      }

      if (selectedAd) {
        await updateAdvertisement(selectedAd.id, formData);
        adId = selectedAd.id;

      }
      else {
        res = await createAdvertisement(formData);
        console.log("rs", res);

        const adsList = await fetchAllAdvertisement();


        const lastAd = adsList[adsList.length - 1];

        adId = lastAd.id;

      }

      if (Array.isArray(visitingTime) && visitingTime.length > 0) {
        await saveVisitingTime({
          adId,
          visitingTimes: visitingTime.map(v => ({
            id: v.id ?? 0,
            location: v.location || "",
            days: v.days || "",
            time: v.time || ""
          }))
        });
        if (removedVisitingIds.length > 0) {
          for (const vtId of removedVisitingIds) {
            await deleteVisitingTime(vtId); 
          }
          setRemovedVisitingIds([]);
        }
      }
      const updatedAds = await fetchAllAdvertisement();
      setAds(updatedAds);

      toast("Advertisement and Visiting Time saved successfully", "SUCCESS");
      setShowModal(false);
      setSelectedAd(null);
      setViewMode(false);
      await loadAds();
    } catch (error) {
      toast("Error in save Advertisement", "ERROR");
    } finally {
      setSaving(false);
    }
  };

  const handleEdit = async (ad) => {
    try {
      setLoading(true);
      const [visiting, attachments] = await Promise.all([
        fetchVisitingTimeByAdId(ad.id),
        fetchAdvAttachmentsByAdId(ad.id),
      ]);

      const visitingTimeArr = Array.isArray(visiting) && visiting.length > 0
        ? visiting
        : [{ location: "", days: "", time: "" }];

      setRemovedAttachmentIds([]);
      setSelectedAd({
        ...ad,
        visitingTime: visitingTimeArr,
        attachments: Array.isArray(attachments) ? attachments : [],
        pdfFiles: [],
      });
      setViewMode(false);
      setShowModal(true);
    } catch (error) {
      toast("Error fetching advertisement details", "ERROR");
    } finally {
      setLoading(false);
    }
  };

  const handleView = async (ad) => {
    try {
      setLoading(true);

      const [visiting, attachments] = await Promise.all([
        fetchVisitingTimeByAdId(ad.id),
        fetchAdvAttachmentsByAdId(ad.id),
      ]);

      const visitingTimeArr = Array.isArray(visiting) && visiting.length > 0
        ? visiting
        : [{ id: 0, location: "", days: "", time: "" }];

      setSelectedAd({ ...ad, visitingTime: visitingTimeArr });
      setViewMode(true);
      setShowModal(true);
    } catch (error) {
      toast("Error fetching advertisement details", "ERROR");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this ad?")) {
      try {
        setDeletingId(id);
        await deleteVisitingTimeByAdId(id);
        await deleteAdvertisement(id);
        toast("Advertisement and visitingTime deleted", "SUCCESS");
        await loadAds();

      } catch (error) {
        toast("Error in delete Advertisement and visitingTime", "ERROR");
      } finally {
        setDeletingId(null);
      }
    }
  };

  return (
    <Main>
      <PageContainer
        title="Advertisement"
        buttonText={loading ? "Loading..." : "ADD"}
        onButtonClick={() => {
          setSelectedAd(null);
          setViewMode(false);
          setRemovedAttachmentIds([]);
          setShowModal(true);
        }}
      >
        <Modal
          visible={showModal}
          size="lg"
          onClose={() => {
            setShowModal(false);
            setSelectedAd(null);
            setViewMode(false);
            setRemovedAttachmentIds([]);
          }}
          headerText={
            viewMode
              ? "View Advertisement"
              : selectedAd
                ? "Edit Advertisement"
                : "Add Advertisement"
          }
          centered
        >
          <AdvertisementForm
            initialData={selectedAd}
            readOnly={viewMode}
            onSave={handleSave}
            loading={loading}
            setLoading={setLoading}
            setRemovedVisitingIds={setRemovedVisitingIds}
            setRemovedAttachmentIds={setRemovedAttachmentIds}
          />

          {viewMode && (
            <div className="d-flex justify-content-end mt-3">
              <button
                className="btn btn-success"
                onClick={() => {
                  setLoading(true);
                  setTimeout(() => {
                    setViewMode(false);
                    setLoading(false);
                  }, 200);
                }}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Loading...
                  </>
                ) : (
                  "Edit"
                )}
              </button>
            </div>
          )}
        </Modal>

        <CollapseCard title="Advertisement List">
          <AdvertisementList
            ads={ads}
            onEdit={handleEdit}
            onDelete={handleDelete}
            onView={handleView}
            deletingId={deletingId}
          />
        </CollapseCard>
      </PageContainer>
    </Main>
  );
};

export default Advertisement;
